// extracted by mini-css-extract-plugin
module.exports = {"col":"footer-menu_col__BvI47","title":"footer-menu_title__A6kQF","list":"footer-menu_list__4ZuVp","sep":"footer-menu_sep__f7Qwo"};